<div class="flex flex-col gap-2">
    <input
        type="text"
        formControlName="name"
        name="name"
        required
        (keyup)="handleKeyDown($event)"
        class="w-full input"
    />
    <div class="flex gap-3 items-center flex-wrap">
        @for (item of value(); track $index) {
        <app-name-tag (emit)="removeChip($index)">{{ item }}</app-name-tag>
        }
    </div>
</div>
